/**
 * @packageDocumentation
 * @module      System.ts
 * @description Bundles a system, its devices, and its dedicated user for calls to the /systemEx API endpoints on the server
 * @copyright   Copyright (c) 2021 by Corindus Inc., a Siemens Healthineers Company. All rights reserved.
 */
import System from "./System";
import UserDetails from "./UserDetails";
export default class SystemEx {
    constructor(sys, usr) {
        this.system = sys || new System();
        this.user = usr;
    }
    toJSON() {
        return {
            system: this.system.toJSON(),
            user: this.user ? Object.assign({}, this.user) : undefined
        };
    }
    static fromJSON(json) {
        let sysEx = new SystemEx(System.fromJSON(json.system));
        if (json.user) {
            sysEx.user = UserDetails.fromJSON(json.user);
        }
        return sysEx;
    }
}
//# sourceMappingURL=SystemEx.js.map